import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {




  url = environment.serverAPI5 + "/api/posproducts";

  constructor(private http: HttpClient) { }

  getAllProduct(Page: any, size: any, sort: any, warehouseId?: any): Observable<Object> {
    const warehouseParam = warehouseId ? `&warehouseId=${warehouseId}` : '';
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}${warehouseParam}`);
  }

  getAllProductDropDown(warehouseId?: any): Observable<Object> {
    const warehouseParam = warehouseId ? `?warehouseId=${warehouseId}` : '';
    return this.http.get(`${this.url}/dropdown${warehouseParam}`);
  }


  getProductById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditProduct(products: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, products);
  }

  ProductSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  downloadReportTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downloadReport() {
    return this.http.get(`${this.url}/exceltemplate/export`, { responseType: 'arraybuffer', observe: 'response' });
  }


  getShopData(): Observable<Object> {
    return this.http.get(`${this.url}/products`);
  }

  saveShopSetting(products: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/products`, products);
  }


}
